import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from "../../utility/Redux/modal";
import { CallAPIPromise } from "../../billing/common";

export const saveSectionMasterApi = (
  setSecFocus,
  secName,
  rows,
  dispatch,
  listSectionMasterApi,
  prefix,
  id,
  setId,
  setSectionList,
  token,
  setSecName,
  afterCreate
) => {
  if (secName) {
    const isDuplicateMobile = rows.some((row) => row.SECTION_NAME === secName);

    if (isDuplicateMobile) {
      dispatch(
        setAlertWithTitle({
          title: "Information Error!",
          msg: "This Section is already exists. Please choose a different section.",
        })
      );
      if (setSecFocus) {
        // setSecName("");
        setSecFocus();
      }

      return;
    }

    const data = {
      table_prefix: prefix,
      CODE: id ? id : "",
      SECTION_NAME: secName,
    };
    id
      ? dispatch(setSpinnerLoading("Updating"))
      : dispatch(setSpinnerLoading("Saving"));
    CallAPIPromise(`/api/subitemMaster/saveSectionMaster`, data, token)
      .then(async function (response) {
        if (!response.data.error) {
          id
            ? dispatch(
                setAlertWithTitle({
                  title: "Success.",
                  msg: "Data Updated successfully.",
                  lottie: "success",
                })
              )
            : dispatch(
                setAlertWithTitle({
                  title: "Success.",
                  msg: "Data Saved successfully.",
                  lottie: "success",
                })
              );
          listSectionMasterApi();
          dispatch(setSectionList([]));
          if (afterCreate) {
            afterCreate();
          }
        } else {
          dispatch(
            setAlertWithTitle({
              title: "Error 112",
              msg: response.data.error,
            })
          );
        }
      })
      .catch(function (error) {
        if (error.response.data.name === "TokenExpiredError") {
          dispatch(setSessionExpired(true));
        }
        dispatch(
          setAlertWithTitle({
            title: "ERROR",
            msg: "Something went wrong.",
            lottie: "reject",
          })
        );
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
        setSecName("");
        if (setId) {
          setId("");
        }
      });
  } else {
    if (!secName) {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Please Enter Section Name.",
        })
      );
      setSecFocus();
    }
  }
};
